import { cva } from "class-variance-authority"

export const cardVariants = cva("bg-white flex gap-4", {
  variants: {
    layout: {
      horizontal: "flex-row",
      vertical: "flex-col",
    },
    variant: {
      default: "gap-6",
      compact: "gap-4",
      standard: "gap-2",
    },
  },
})

export const imageVariants = cva("rounded-full object-cover", {
  variants: {
    variant: {
      default: "w-30 h-30",
      compact: "w-18 h-18 md:w-24 md:h-24",
      standard: "w-25 h-25",
    },
  },
})


export const titleVariants = cva("text-neutral-60-primary-text", {
  variants: {
    variant: {
      default: "text-xl font-semibold",
      compact: "text-base font-medium",
      standard: "text-2xl font-medium",
    },
  },
})

export const itemVariants = cva("text-neutral-50-secondary-text flex", {
  variants: {
    variant: {
      default: "text-sm gap-1",
      compact: "text-sm gap-1",
      standard: "text-base gap-2",
    },
  },
})
